import React from 'react';
import { AssetBlockProps } from '../../pages/Asset';

interface MapProps extends AssetBlockProps {
  showMap: () => void;
}

const Map: React.FC<MapProps> = ({ asset, showMap }) => {
  const width = window.innerWidth;
  const lat = asset.mapInformation?.location.lat || 0;
  const long = asset.mapInformation?.location.long || 0;

  return (
    <div>
      <div
        onClick={() => {
          showMap();
        }}
        style={{ borderRadius: 10, marginTop: 36 }}>
        <img
          style={{ borderRadius: 10, width: '100%' }}
          src={`https://maps.googleapis.com/maps/api/staticmap?center=${lat},${long}&zoom=11&size=${width}x150&style=&markers=${lat},${long}&key=AIzaSyAZKMoXSNlcFPxTCT3nVY5GsOBItH_OHTg`}></img>
      </div>
    </div>
  );
};

export default Map;
